import styled from 'styled-components';

export const StyledHeader = styled.div`
  display: flex;
  padding: ${({ $hasLogoUrl, theme }) =>
    $hasLogoUrl && theme.header.hasLogo ? theme.header.paddingWithLogoMobile : theme.header.paddingMobile};
  background: var(--color-widgetBackground);
  flex: 1;
  border-radius: ${({ theme }) => theme.standardRadius};

  .-desktop & {
    padding: ${({ $hasLogoUrl, theme }) =>
      $hasLogoUrl && theme.header.hasLogo ? theme.header.paddingWithLogo : theme.header.padding};
    display: block;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .-mobile & {
    align-items: center;
    height: 64px;
  }
`;
